export var useAgentData = function () {
    var getAgentFullName = function (agent) {
        var firstName = agent.firstName || '';
        var lastName = agent.lastName || '';
        return ("".concat(firstName, " ").concat(lastName).trim() || agent.userName || 'Unknown Agent');
    };
    var isAgentAvailable = function (agent) { var _a; return agent.isActive && ((_a = agent.agentStateName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'available'; };
    var getAgentId = function (agent) { var _a; return ((_a = agent.agentId) === null || _a === void 0 ? void 0 : _a.toString()) || agent.userId || ''; };
    var getAgentState = function (agent) {
        return agent.agentStateName || 'Unknown';
    };
    return { getAgentFullName: getAgentFullName, isAgentAvailable: isAgentAvailable, getAgentId: getAgentId, getAgentState: getAgentState };
};
